module.exports = __webpack_public_path__ + "img/img-login-concorsando.aceb0f40.png";